import axios from 'axios'

export const state = {
  promotion: [],
}

export const getters = {
  getPromotion() {
    return state.promo
  },
}

export const mutations = {
  SET_PROMOTION(state, promo) {
    state.companies = promo
  },
}

export const actions = {
  insertPromotion({
    commit,
    state
  }, {
    promotionDetails
  }) {
    return axios.post(`v1/promotion/`, promotionDetails).then(response => {
      return response
    })
  },
  getPromotion({
    commit
  }, groupId) {
    return axios.get(`v1/promotion/${groupId}`).then(response => {
      return response
    })
  },
  setPromotion({
    commit,
    state
  }, promo) {
    commit('SET_PROMOTION', promo)
  },
  updatePromotion({
    commit,
    state
  }, {
    promotionDetails
  }) {
    return axios
      .put(`v1/promotion/`, promotionDetails)
      .then(response => {
        return response
      })
  },


}
